import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedCircleX = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 24,
	viewBox: "0 0 26 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M13 2.25C9.48438 2.25 6.29688 4.125 4.51562 7.125C2.78125 10.1719 2.78125 13.875 4.51562 16.875C6.29688 19.9219 9.48438 21.75 13 21.75C16.4688 21.75 19.6562 19.9219 21.4375 16.875C23.1719 13.875 23.1719 10.1719 21.4375 7.125C19.6562 4.125 16.4688 2.25 13 2.25ZM13 24C8.6875 24 4.75 21.75 2.59375 18C0.4375 14.2969 0.4375 9.75 2.59375 6C4.75 2.29688 8.6875 0 13 0C17.2656 0 21.2031 2.29688 23.3594 6C25.5156 9.75 25.5156 14.2969 23.3594 18C21.2031 21.75 17.2656 24 13 24ZM9.71875 6.42188L13 10.2656L16.2344 6.42188C16.6562 5.95312 17.3594 5.90625 17.8281 6.28125C18.2969 6.70312 18.3438 7.40625 17.9688 7.875L14.4531 12L17.9688 16.1719C18.3438 16.6406 18.2969 17.3438 17.8281 17.7656C17.3594 18.1406 16.6562 18.0938 16.2344 17.625L13 13.7812L9.71875 17.625C9.29688 18.0938 8.59375 18.1406 8.125 17.7656C7.65625 17.3438 7.60938 16.6406 7.98438 16.1719L11.5 12L7.98438 7.875C7.60938 7.40625 7.65625 6.70312 8.125 6.28125C8.59375 5.90625 9.29688 5.95312 9.71875 6.42188Z",
		fill: "#D91734"
	})]
});
const ForwardRef = forwardRef(SvgRedCircleX);
export { ForwardRef as ReactComponent };
